import { CSS_INJECTION_POINT_TOKEN } from "@asosteam/asos-web-template-assembly/constants";
import Token from "../Token";
import { fragmentBoundaryToken } from "./fragmentBoundaryToken";
import { isFragmentationMode } from "./isFragmentationMode";

const cssInjectPointToken = `<!--${CSS_INJECTION_POINT_TOKEN}%-->`;

const FragmentBoundaryToken = () =>
  isFragmentationMode ? <Token value={fragmentBoundaryToken} /> : null;

const CssInjectionPointToken = () =>
  isFragmentationMode ? <Token value={cssInjectPointToken} /> : null;

export default {
  FragmentBoundaryToken,
  CssInjectionPointToken
};
